import React, { useState } from "react";

const AuthContext = React.createContext({});

function AuthProvider(props){
   
    let islogin = false;
    const login = JSON.parse(localStorage.getItem("login")) 
    if(login){
       islogin = true
    }else{
       islogin = false;
    }
   
    const [logado,setLogado] = useState(islogin === true ? true : false);
    const [status,setStatus] = useState('');
    const [cgcglobal,setCgcglobal] = useState('');
    const [codcli,setCodcli] = useState('');
    const [dadosped,setDadosPed] = useState([]);
    const [dadosass,setDadosAss] = useState([]);
    const [modalIsOpenE, setIsOpenE] = useState(false);
    const [modalIsOpenW, setIsOpenW] = useState(false);
    const [modalIsOpenF, setIsOpenF] = useState(false);
    const [modalIsOpenL, setIsOpenL] = useState(false);
    const [modalIsOpenBol, setIsOpenBol] = useState(false);
    const [filtro,setFiltro] = useState('Todos');
    const [tipo,setTipo] = useState('3');
    const [numwats,setNumwats] = useState('');
    const [whabol,setWhabol] = useState('');
    const [qtdfun,setQtdfun] = useState('');
    const [fatcli,setFatcli] = useState('');
   
    return(
     <AuthContext.Provider value={{
                                    logado,setLogado, //Se login foi feito
                                    status,setStatus,  //Status , se eh login, primrio acesso ,recuperação de senha etc.....
                                    cgcglobal,setCgcglobal, //grava cnpj para aplicacao toda
                                    codcli,setCodcli,
                                    dadosped,setDadosPed,
                                    modalIsOpenE,setIsOpenE,
                                    modalIsOpenW,setIsOpenW,
                                    modalIsOpenF,setIsOpenF,
                                    modalIsOpenL,setIsOpenL,
                                    modalIsOpenBol,setIsOpenBol,
                                    filtro,setFiltro,
                                    tipo,setTipo,
                                    numwats,setNumwats,
                                    whabol,setWhabol,
                                    qtdfun,setQtdfun,
                                    fatcli,setFatcli,
                                    dadosass,setDadosAss
                                  }}>
        {props.children}
     </AuthContext.Provider>
   )

}

export {AuthContext,AuthProvider};